module.exports = __webpack_public_path__ + "static/img/1.ef7941e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/meizu/1.png
// module id = TVFQ
// module chunks = 0